import { Injectable } from '@angular/core';

import 'devextreme/localization/globalize/number';
import 'devextreme/localization/globalize/date';
import 'devextreme/localization/globalize/currency';
import 'devextreme/localization/globalize/message';

// Dictionaries
import frMessages from 'devextreme/localization/messages/fr.json';

// Common and language-specific CLDR JSONs
import supplemental from 'devextreme-cldr-data/supplemental.json';
import frCldrData from 'devextreme-cldr-data/fr.json';

import Globalize from 'globalize';

@Injectable()
export class DevExtremeTranslationService {

    private ActualLanguage = '';

    constructor() { }
    loadLanguage(language: string) {
        if (this.ActualLanguage !== language) {
            // TODO Add other languages
            switch (language) {
                case 'fr':
                    Globalize.load(
                        frCldrData,
                        supplemental
                    );
                    Globalize.loadMessages(frMessages);
                    break;
                default:
                    break;
            }
            Globalize.locale(language);
            this.ActualLanguage = language;
        }
    }
}
